module.exports = __webpack_public_path__ + "img/btn-close.8088e415.png";